var map = {
	"./american-express.png": "1af4",
	"./amex.png": "0a77",
	"./aura.png": "2afd",
	"./cartao-default.svg": "1b86",
	"./diners.png": "9923",
	"./dinersclub.png": "71a5",
	"./discover.png": "9447",
	"./elo.png": "bfbe",
	"./hipercard.png": "44ce",
	"./jcb.png": "d3c2",
	"./maestro.png": "5f30",
	"./mastercard.png": "396f",
	"./visa.png": "4ea6",
	"./visaelectron.png": "749b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b556";